<span
  [ngClass]="{
    'status-ok': sentiment() === 'POSITIVE',
    'status-warn': sentiment() === 'WARNING',
    'status-error': sentiment() === 'NEGATIVE',
  }"
>
  <ng-content></ng-content>
</span>
